import { Stack } from 'ui/stack';

import ResponsiveWrapper from 'components/shared/others/responsive-wrapper/responsive-wrapper';
import { Typography } from 'ui/typography';
import { Loader } from 'ui/loader';
import EmptySpaceContent from 'components/partials/empty-space-content/empty-space-content';

import InsightItem from 'containers/user/insights/insight-item';
import useInsights from 'containers/user/insights/use-insights';

import Icons from 'assets/icons';

const Insights = (): React.JSX.Element => {
  const { loading, insights } = useInsights();

  return (
    <ResponsiveWrapper customClass="mt-8 flex flex-col">
      <Loader loading={loading} fullScreen={false} />
      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
          mb: 3,
          gap: 2,
          '@media (min-width: 375px)': { justifyContent: 'center' },
          '@media (min-width: 780px)': { justifyContent: 'flex-start' },
        }}
      >
        <Typography data-testid="my-insights-heading" variant="h1">
          Insights
        </Typography>
      </Stack>

      {!loading && insights.length === 0 ? (
        <Stack role="status" aria-live="polite" sx={{ flex: '1 1 0%' }}>
          <EmptySpaceContent
            customClass="flex-1"
            image={
              <Icons.EmptyImage customClass="size-20" aria-hidden="true" />
            }
            text="No insights have been shared yet"
          />
        </Stack>
      ) : (
        <Stack
          direction="row"
          sx={{
            flexWrap: 'wrap',
            gap: 2,
            mt: 2,
            '@media (min-width: 375px)': { justifyContent: 'center' },
            '@media (min-width: 780px)': { justifyContent: 'flex-start' },
          }}
        >
          {insights.map((insight) => (
            <InsightItem key={insight.id} insight={insight} />
          ))}
        </Stack>
      )}
    </ResponsiveWrapper>
  );
};

export default Insights;
